import { Group } from '../../models/Group'
import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useUpdateGroup() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (group: { uuid: string } & Pick<Group, 'name'>) => {
      await api.put(`group/${encodeURIComponent(group.uuid)}`, {
        name: group.name,
      })
      await invalidate.groups()
    },
  })
}
